import { render, staticRenderFns } from "./lahanUmumCreate.vue?vue&type=template&id=28d3fc5d"
import script from "./lahanUmumCreate.vue?vue&type=script&lang=js"
export * from "./lahanUmumCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports